/**
 * components/MobilDetailModal.js
 * Shows all items that fit a given car model. Each row is clickable to jump to that item's detail.
 */
import React from "react";
import { fmtQty } from "../utils/idGenerators";
import { useModalEsc, backdropClose } from "../utils/modalStack";

export default function MobilDetailModal({ car, onClose, onOpenItem }) {
  useModalEsc(onClose);

  if (!car) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onMouseDown={backdropClose(onClose)}>
      <div className="modal-box modal-box--detail" onMouseDown={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" onClick={onClose} aria-label="Tutup">×</button>

        <div className="modal-detail__head">
          <h2 className="modal-title">{car.name}</h2>
          <div className="page-sub">{car.items.length} barang cocok</div>
        </div>

        <div className="card">
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Kode Internal</th>
                  <th>Nama</th>
                  <th>Kategori</th>
                  <th className="num">Stok Pusat</th>
                  <th className="num">Stok Cabang</th>
                  <th className="num">Total</th>
                </tr>
              </thead>
              <tbody>
                {car.items.map((it) => {
                  const pusat = Number(it.stokPusat) || 0;
                  const cabang = Number(it.stokCabang) || 0;
                  const total = pusat + cabang;
                  return (
                    <tr key={it.internalCode} style={{ cursor: "pointer" }} onClick={() => onOpenItem(it.internalCode)}>
                      <td className="mono">{it.internalCode}</td>
                      <td>
                        {it.name}
                        {it.isSet === true && <span className="chip chip--set" style={{ marginLeft: "var(--gap-sm)" }}>SET</span>}
                      </td>
                      <td>{it.category || "—"}</td>
                      <td className="num">{fmtQty(pusat)}</td>
                      <td className="num">{fmtQty(cabang)}</td>
                      <td className="num">{fmtQty(total)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Tutup</button>
        </div>
      </div>
    </div>
  );
}
